import { combineReducers } from 'redux';
import { reducer as formReducer } from 'antd-form-redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import examplesReducer from '../features/examples/redux/reducer';
import masterPageReducer from '../features/master-page/redux/reducer';
import componentesReducer from '../features/componentes/redux/reducer';
import acessoSistemaReducer from '../features/acesso-sistema/redux/reducer';
import pessoasReducer from '../features/pessoas/redux/reducer';
import storageReducer from '../features/storage/redux/reducer';
import parametrosSistemaReducer from '../features/parametros-sistema/redux/reducer';
import pagesReducer from '../features/pages/redux/reducer';
import usuariosReducer from '../features/usuarios/redux/reducer';
import usuarioPerfilReducer from '../features/usuario-perfil/redux/reducer';
import arquivosReducer from '../features/arquivos/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import loginSapReducer from '../features/login-sap/redux/reducer';
import logsSistemaReducer from '../features/logs-sistema/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  form: formReducer,
  router: routerReducer,
  home: homeReducer,
  examples: examplesReducer,
  masterPage: masterPageReducer,
  componentes: componentesReducer,
  acessoSistema: acessoSistemaReducer,
  pessoas: pessoasReducer,
  storage: storageReducer,
  parametrosSistema: parametrosSistemaReducer,
  pages: pagesReducer,
  usuarios: usuariosReducer,
  usuarioPerfil: usuarioPerfilReducer,
  arquivos: arquivosReducer,
  common: commonReducer,
  loginSap: loginSapReducer,
  logsSistema: logsSistemaReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js